import Marquee from "react-fast-marquee";
import { useLang } from "@/i18n/LanguageContext";

export default function BrandMarquee() {
  const { t } = useLang();
  const line = `  ${t.marquee}  `;
  const repeats = 6;
  const text = Array.from({ length: repeats }).map(() => line).join("");

  return (
    <section
      data-testid="marquee-section"
      className="relative bg-black border-y border-white/10 py-8 md:py-12 marquee-slow overflow-hidden"
    >
      <Marquee
        gradient={false}
        speed={40}
        pauseOnHover={false}
      >
        <span className="font-display text-white text-[52px] md:text-[92px] lg:text-[112px] leading-none tracking-tighter">
          {text}
        </span>
      </Marquee>
      <Marquee
        gradient={false}
        speed={30}
        direction="right"
        pauseOnHover={false}
        className="mt-2 opacity-30"
      >
        <span className="stroke-text font-display text-[52px] md:text-[92px] lg:text-[112px] leading-none tracking-tighter">
          {text}
        </span>
      </Marquee>
    </section>
  );
}
